import * as React from "react";
import PropTypes from "prop-types";

import { Card, Grid, Icon } from "@mui/material";
import SoftBox from "components/SoftBox";
import { useEffect, useState } from "react";
import SoftTypography from "components/SoftTypography";
import "assets/theme/base/animation.css";
import defaultTeamLogo from "assets/images/default_team_logo.png";

const globalCss = require("assets/theme/base/globals");
const _ = require("lodash");

function OponentsView({ event, openBackDrop, informParent }) {
  const [diffTimer, setDiffTimer] = useState(null);

  const css = globalCss ? globalCss.default : null;
  const customColors = css.customColors;

  function timeDifference(date1, date2) {
    var difference = date1.getTime() - date2.getTime();

    var daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
    difference -= daysDifference * 1000 * 60 * 60 * 24;

    var hoursDifference = Math.floor(difference / 1000 / 60 / 60);
    difference -= hoursDifference * 1000 * 60 * 60;

    var minutesDifference = Math.floor(difference / 1000 / 60);
    difference -= minutesDifference * 1000 * 60;

    var secondsDifference = Math.floor(difference / 1000);
    return (
      daysDifference + ":" + hoursDifference + ":" + minutesDifference + ":" + secondsDifference
    );
  }

  function countDiffUpdate() {
    if (event) {
      let now = new Date();
      let lastUpdate = new Date(event.fixtureInfo.lastUpdate);
      event.fixtureInfo.lastUpdateLabel = lastUpdate.toLocaleString("en-GB");
      event.fixtureInfo.diff = timeDifference(now, lastUpdate);
    }
  }

  function handleProducts(e, product) {}

  useEffect(() => {
    // console.log("Event: ", event);
    if (event) {
      if (!diffTimer) {
        countDiffUpdate();
        let int = setInterval(countDiffUpdate, 1000);
        setDiffTimer(int);
      } else {
        clearInterval(diffTimer);
        setDiffTimer(null);
        countDiffUpdate();
        let int = setInterval(countDiffUpdate, 1000);
        setDiffTimer(int);
      }
    }
  }, [event]);

  useEffect(() => {
    if (!diffTimer) {
      let int = setInterval(countDiffUpdate, 1000);
      setDiffTimer(int);
    }
  }, []);

  return event ? (
    <React.Fragment>
      <Card style={{ width: "100%", background: "rgb(57, 57, 57)" }}>
        <div
          style={{ backgroundColor: "#ffffff80" }}
          className={event ? "fixture-header-" + event.fixtureInfo.sport.id : "fixture-header"}
        ></div>
        <div className="fixture-data">
          <SoftBox>
            <Grid container className="region-competion-breadcramp">
              <Grid item sm={7}>
                <SoftTypography
                  variant=""
                  style={{
                    display: event.providerName ? "" : "none",
                    fontSize: "0.75rem",

                    textShadow: "0px 0px 5px #cececece",
                  }}
                  sx={{
                    backgroundColor: customColors[event.providerName],
                    borderRadius: "50px",
                    minWidth: "75px",
                    boxShadow: "0px 0px 1px #ffffffa1",
                    padding: "5px 5px 5px 7px",
                    color: "#fff",
                    textShadow: "0px 0px 2px #000 !important",
                  }}
                  // className={"provider-" + rowData.provider + "-competition"}
                >
                  {"  "}
                  {event.providerName}
                  {"  "}
                </SoftTypography>
                <Icon style={{ paddingTop: "2px" }}>keyboard_arrow_right_outlined_icon</Icon>
                {event.fixtureInfo.sport.name}{" "}
                <Icon style={{ paddingTop: "2px" }}>keyboard_arrow_right_outlined_icon</Icon>{" "}
                {event.region}{" "}
                <Icon style={{ paddingTop: "2px" }}>keyboard_arrow_right_outlined_icon</Icon>{" "}
                {event.league}{" "}
              </Grid>
              <Grid item sm={5} style={{ textAlign: "right", opacity: 0.7 }}>
                <SoftTypography sx={{ fontSize: "0.85rem !important", color: "#fff" }}>
                  Start Date: {event.date}
                </SoftTypography>
              </Grid>
            </Grid>
          </SoftBox>
          <SoftBox
            display=" flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="flex-start"
            p={1}
          >
            <Grid container>
              <Grid item className="fixture-oponent">
                <Grid container sx={{ flexDirection: "column" }}>
                  <Grid item>
                    <img
                      className={
                        event.fixtureInfo.participants[0].logo
                          ? "participant-logo"
                          : "default-participant-logo"
                      }
                      src={
                        event.fixtureInfo.participants[0].logo
                          ? event.fixtureInfo.participants[0].logo
                          : defaultTeamLogo
                      }
                    />
                  </Grid>
                  <Grid item>
                    <SoftTypography sx={{ color: "#fff" }} style={{ filter: "0px 0px 5px #000" }}>
                      {event.home}
                    </SoftTypography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <SoftTypography style={{ fontSize: "2rem", color: "#fff" }}>VS</SoftTypography>
              </Grid>
              <Grid item className="fixture-oponent">
                <Grid container sx={{ flexDirection: "column" }}>
                  <Grid item>
                    <img
                      className={
                        event.fixtureInfo.participants[1].logo
                          ? "participant-logo"
                          : "default-participant-logo"
                      }
                      src={
                        event.fixtureInfo.participants[1].logo
                          ? event.fixtureInfo.participants[1].logo
                          : defaultTeamLogo
                      }
                    />
                  </Grid>
                  <Grid item>
                    <SoftTypography sx={{ color: "#fff", filter: "0px 0px 5px #000" }}>
                      {event.away}
                    </SoftTypography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </SoftBox>
          <SoftBox
            display=" flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="flex-start"
            p={1}
          >
            <Grid container sx={{ position: "relative", top: "-45px", height: "0px" }}>
              <Grid item className="fixture-oponent">
                <SoftTypography sx={{ color: "#fff" }}> </SoftTypography>
              </Grid>
              <Grid item>
                <SoftTypography style={{ fontSize: "0.85rem", color: "#fff" }}>
                  {event.fixtureInfo.status}
                </SoftTypography>
                <SoftTypography style={{ fontSize: "0.85rem", color: "#fff" }}>
                  state:{" "}
                  {_.get(event, "live.scoreBoard.state")
                    ? _.get(event, "live.scoreBoard.state")
                    : "-"}
                </SoftTypography>
                <span
                  style={{ display: event.fixtureInfo.status == "In progress" ? "" : "none" }}
                  className="playing-time"
                ></span>
              </Grid>
              <Grid item className="fixture-oponent">
                <SoftTypography sx={{ color: "#fff" }}> </SoftTypography>
              </Grid>
            </Grid>
          </SoftBox>
          <SoftBox>
            <Grid container className="fixture-overview-footer">
              <Grid item sm={7}>
                <Grid item style={{ textAlign: "left", opacity: 0.7 }}>
                  <Grid container sx={{ display: "block", textAlign: "left" }}>
                    <SoftTypography variant="caption" sx={{ fontSize: "0.75rem", color: "#fff" }}>
                      Last Update:{"  "}
                    </SoftTypography>
                    <SoftTypography
                      variant="caption"
                      sx={{
                        fontSize: "0.85rem",
                        color: "yellow",
                      }}
                    >
                      {event.fixtureInfo.diff}
                      {"  "}
                    </SoftTypography>
                    <SoftTypography
                      variant="caption"
                      sx={{
                        fontSize: "0.65rem",
                        color: "#fff",
                        display: openBackDrop ? "none" : "",
                      }}
                    >
                      ({event.fixtureInfo.lastUpdateLabel}
                      {"  "}
                    </SoftTypography>
                    <SoftTypography
                      variant="caption"
                      sx={{
                        fontSize: "0.65rem",
                        color: "#fff",
                        display: openBackDrop ? "none" : "",
                      }}
                    >
                      locale time)
                    </SoftTypography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item sm={5} sx={{ color: "#fff" }}>
                <Grid container sx={{ display: "block ruby" }}>
                  <Grid item sx={{ paddingLeft: "5px" }}>
                    <Icon
                      style={{ cursor: "help", fontSize: "0.85rem !important" }}
                      className={_.get(event, "live.scoreBoard") ? "" : "disabled-form-item"}
                      title={
                        _.get(event, "live.scoreBoard")
                          ? "Scoreboard Available"
                          : "Scoreboard NOT Available"
                      }
                      onClick={(e) => informParent(e, "scoreboard")}
                    >
                      scoreboard_outlined_icon{" "}
                    </Icon>
                  </Grid>
                  <Grid item sx={{ paddingLeft: "5px" }}>
                    <Icon
                      style={{ cursor: "help", fontSize: "0.85rem !important" }}
                      className={
                        _.get(event, "live.timeline") &&
                        event.live.timeline.length > 0 &&
                        event.live.timeline.filter((te) => te.participant).length > 0
                          ? ""
                          : "disabled-form-item"
                      }
                      title={
                        _.get(event, "live.timeline") &&
                        event.live.timeline.filter((te) => te.participant).length > 0
                          ? "Summary Available"
                          : "Summary NOT Available"
                      }
                      onClick={(e) => informParent(e, "timeline")}
                    >
                      format_list_bulleted_outlined_icon{" "}
                    </Icon>
                  </Grid>
                  <Grid item sx={{ paddingLeft: "5px" }}>
                    <Icon
                      style={{ cursor: "help", fontSize: "0.85rem !important" }}
                      className={_.get(event, "live.scoreBoard") ? "" : "disabled-form-item"}
                      title={
                        _.get(event, "live.scoreBoard")
                          ? "Live Stats Available"
                          : "Live Stats NOT Available"
                      }
                      onClick={(e) => informParent(e, "liveStats")}
                    >
                      data_saver_off_outlined_icon{" "}
                    </Icon>
                  </Grid>
                  <Grid item sx={{ paddingLeft: "5px" }}>
                    <Icon
                      style={{ cursor: "help", fontSize: "0.85rem !important" }}
                      className={
                        _.get(event, "fixtureInfo.virtualCourtId") &&
                        event.fixtureInfo.status == "In progress"
                          ? ""
                          : "disabled-form-item"
                      }
                      title={
                        _.get(event, "fixtureInfo.virtualCourtId") &&
                        event.fixtureInfo.status == "In progress"
                          ? "Virtual-Court Available"
                          : "Virtual-Court NOT Available"
                      }
                      onClick={(e) => informParent(e, "vlcourt")}
                    >
                      live_tv_outlined_icon{" "}
                    </Icon>
                  </Grid>
                  <Grid item sx={{ paddingLeft: "5px" }}>
                    <Icon
                      style={{ cursor: "help", fontSize: "0.85rem !important" }}
                      className={_.get(event, "fixtureInfo.statsId") ? "" : "disabled-form-item"}
                      title={
                        _.get(event, "fixtureInfo.statsId")
                          ? "Pregame stats Available: " + _.get(event, "fixtureInfo.statsId")
                          : "Pregame stats NOT Available"
                      }
                      onClick={(e) => informParent(e, "stats")}
                    >
                      leaderboard_outlined_icon{" "}
                    </Icon>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </SoftBox>
        </div>
      </Card>
    </React.Fragment>
  ) : (
    ""
  );
}

// Typechecking props for the DataTable
OponentsView.propTypes = {
  event: PropTypes.object,
  openBackDrop: PropTypes.bool,
  informParent: PropTypes.func,
};

export default OponentsView;
